import * as React from 'react';

// Filters on date and dateTime grid columns (CP-3420).
//
// A date filter's value is a wall clock -- a day ("2026-10-16") or a minute ("2026-10-16T08:11")
// -- in the zone the column displays, which for these grids is the viewer's own. The backend
// compares in UTC unless the filter names the zone, so every date filter carries it as `tz`.

const DATE_TYPES = ['date', 'dateTime'];

export const viewerTimeZone = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
    } catch {
        return undefined;
    }
};

// The list API's form of one grid filter item (MUI v5 `columnField`/`operatorValue`, v6
// `field`/`operator`).
export const toApiFilter = (item, columns) => {
    const field = item.columnField || item.field;
    const filter = { field, op: item.operatorValue || item.operator, value: item.value };
    const column = (columns || []).find((c) => c.field === field);
    const tz = column && DATE_TYPES.includes(column.type) ? viewerTimeZone() : undefined;
    return tz ? { ...filter, tz } : filter;
};

// The grid keeps a filter's value across an operator change only while the input component stays
// the same. "is" / "is not" pick a day and the comparisons a minute; neither input can show the
// other's value, so the day input is a component of its own and the switch clears the value.
const DayFilterInput = ({ DateInput, ...props }) => <DateInput {...props} />;

const asDayOperator = (operator) => ({
    ...operator,
    InputComponent: DayFilterInput,
    InputComponentProps: { ...operator.InputComponentProps, DateInput: operator.InputComponent },
});

// Filter operators for a server-filtered date or dateTime column, from the grid version's own
// `getGridDateOperators`. A dateTime column matches "is" and "is not" by day: no stored instant
// equals a picked minute, and "joined on the 16th" is the question people ask.
export const serverDateOperators = (getGridDateOperators, type) => {
    if (type === 'date') {
        return getGridDateOperators(false).filter((o) => !['isEmpty', 'isNotEmpty', 'not'].includes(o.value));
    }
    const byDay = Object.fromEntries(getGridDateOperators(false).map((o) => [o.value, o]));
    return getGridDateOperators(true).map((o) => (['is', 'not'].includes(o.value) ? asDayOperator(byDay[o.value]) : o));
};
